export default function ({app, error}) {
  if (!app.$planHasPermission('application_view')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}
